/* eslint-disable react/no-children-prop */
import React, { FC } from 'react';
import { Stack, HStack, Text, Box } from '@chakra-ui/react';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarRadiusAxis,
  PolarAngleAxis,
  ResponsiveContainer,
} from 'recharts';

interface CardWithGraphicProps {
  institutionName: string;
  data: any;
}

const CardWithGraphic: FC<CardWithGraphicProps> = (props) => {
  const { data, institutionName } = props;
  const minLimit = 0; // Set your minimum limit here
  const maxLimit = 10; // Set your maximum limit here
  return (
    <HStack
      p="15px"
      m="5px"
      h="350px"
      minW="700px"
      boxShadow="0px 0px 7px rgba(0, 0, 0, 0.04)"
      borderRadius="5px"
      background="theme.light.bodySecondary"
      overflowX="auto"
      overflowY="auto"
    >
      <Stack w="90%" h="100%">
        <Text>Média - {institutionName}</Text>
        <ResponsiveContainer width="95%" height={290}>
          <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data ?? []}>
            <Radar name="name" dataKey="average" stroke="#0FADB3" fill=" #0FADB3" />
            <PolarGrid />
            <PolarRadiusAxis domain={[minLimit, maxLimit]} axisLine={false} tick={false} />
            <PolarAngleAxis dataKey="name" />
          </RadarChart>
        </ResponsiveContainer>
      </Stack>
      <Box
        overflowX="auto"
        h="100%"
        w="30%"
        sx={{
          '::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <HStack mb="8px">
          <Text>Notas:</Text>
        </HStack>
        {data?.map((item, index) => (
          <HStack key={item.name || index} mb="8px" justifyContent="space-between">
            <Text>{item.name}</Text>
            <Text>{parseFloat(item.average).toFixed(1)}</Text>
          </HStack>
        ))}
      </Box>
    </HStack>
  );
};

export default CardWithGraphic;
